import React, { useEffect, useState } from "react";
import { Clock, MapPin } from "lucide-react";
import axios from "axios";

export default function Careers() {
  const [jobs, setJobs] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    coverLetter: "",
    resume: null,
  });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs`);
        setJobs(res.data); 
      } catch (err) {
        console.error("Error fetching jobs:", err);
      }
    };
    fetchJobs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, resume: e.target.files[0] }));
  };

  const handleSubmit = async () => {
    try {
      const submission = new FormData();
      submission.append("title", selectedTitle);
      submission.append("firstName", formData.firstName);
      submission.append("lastName", formData.lastName);
      submission.append("email", formData.email);
      submission.append("phone", formData.phone);
      submission.append("coverLetter", formData.coverLetter);
      if (formData.resume) {
        submission.append("resume", formData.resume);
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/api/application/apply`, submission);
      alert("Application submitted successfully!");
      setIsOpen(false);
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit application.");
    }
  };

  return (
    <div className="bg-[#0c0f1c] text-white py-15 px-15">
      <div className="mx-auto">
        <button className="bg-[#432DD7] text-white px-5 w-[257px] h-[60px] font-[Nunito] py-2 rounded-full mb-6 font-semibold">
          Current Openings
        </button>
        <h2 className="text-4xl font-bold" style={{ fontFamily: "PT Sans" }}>
          Explore exciting career
        </h2>
        <p
          style={{ fontFamily: "Allison, sans-serif" }}
          className="italic text-4xl mt-5 text-white mb-6"
        >
          opportunities and join our dynamic team.
        </p>
        <p className="text-white font-[Nunito] text-[16px] mb-8">
          Explore our current job opportunities and find your perfect role at
          Godhani Technology. Join a team of innovators, work on exciting
          projects, and grow your career in a dynamic environment. Take the next
          step toward success with us today!
        </p>

        {jobs.map((job, index) => {
          const requirements = Array.isArray(job.requirements)
            ? job.requirements
            : job.requirements?.split(",").map((r) => r.trim()) || [];

          return (
            <div
              key={index}
              className="bg-[#1c1f30] p-6 rounded-lg shadow-lg mb-6 border border-white"
            >
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-xl font-semibold" style={{ fontFamily: "PT Sans" }}>
                  {job.title}
                </h3>
                <span className="bg-gray-700 text-gray-300 px-3 py-2 font-[Nunito] mr-[67rem] rounded-full text-xs hidden md:block">
                  Featured
                </span>
              </div>

              <div className="flex flex-wrap items-center gap-4 md:gap-6 text-gray-400 mb-3">
                <p className="text-gray-400 font-[Nunito]">Engineering</p>
                <div className="flex items-center gap-2">
                  <Clock size={16} />
                  <span className="font-[Nunito]">{job.type}</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin size={16} />
                  <span className="font-[Nunito]">{job.location}</span>
                </div>

                <div className="ml-auto">
                  <button
                    onClick={() => {
                      setSelectedTitle(job.title);
                      setIsOpen(true);
                    }}
                    className="bg-[#432DD7] font-[Nunito] text-white px-5 py-2 rounded-full font-semibold w-full md:w-auto"
                  >
                    Apply Now →
                  </button>
                </div>
              </div>

              <p className="text-gray-300 font-[Nunito] mb-3">
                We’re looking for an experienced {job.title} to join our team.
              </p>
              <p className="font-semibold font-[Nunito] text-gray-200">Requirements:</p>
              <ul className="list-disc font-[Nunito] list-inside text-gray-400 mb-4">
                {requirements.map((req, i) => (
                  <li key={i}>{req}</li>
                ))}
              </ul>
            </div>
          );
        })}

        {/* Modal Pop-Up */}
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center px-4 overflow-y-auto py-10">
            <div className="bg-white p-6 rounded-lg w-full max-w-3xl relative">
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-3 right-3 text-white w-8 h-8 flex items-center justify-center rounded-full bg-black text-xl font-semibold"
              >
                &times;
              </button>

              {/* Modal Title */}
              <h2 className="text-xl font-bold mb-4 text-center text-black">
                Apply for: {selectedTitle}
              </h2>

              {/* Form Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-black mb-1">First Name</label>
                  <input
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    type="text"
                    className="border border-gray-300 p-2 rounded w-full text-gray-700"
                  />
                </div>
                <div>
                  <label className="block text-black mb-1">Last Name</label>
                  <input
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    type="text"
                    className="border border-gray-300 p-2 rounded w-full text-gray-700"
                  />
                </div>
                <div>
                  <label className="block text-black mb-1">Email</label>
                  <input
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="email"
                    className="border border-gray-300 p-2 rounded w-full text-gray-700"
                  />
                </div>
                <div>
                  <label className="block text-black mb-1">Phone Number</label>
                  <input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    type="text"
                    className="border border-gray-300 p-2 rounded w-full text-gray-700"
                  />
                </div>
              </div>

              {/* Resume Upload */}
              <div className="mt-4">
                <label className="block text-black mb-1">Resume/CV</label>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  className="border border-gray-300 p-2 rounded w-full text-gray-700"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: PDF, DOC, DOCX (Max 5MB)
                </p>
              </div>

              {/* Cover Letter */}
              <div className="mt-4">
                <label className="block text-black mb-1">Cover Letter</label>
                <textarea
                  name="coverLetter"
                  value={formData.coverLetter}
                  onChange={handleChange}
                  className="border border-gray-300 p-2 rounded w-full h-32 text-gray-700"
                />
              </div>

              {/* Submit Button */}
              <div className="flex justify-end mt-6">
                <button
                  onClick={handleSubmit}
                  className="bg-[#432DD7] hover:bg-[#2d1bb5] text-white px-6 py-2 rounded-full transition duration-200"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
